import { useState } from 'react';
import { ShowProps } from 'react-admin';
import { useSelector } from 'react-redux';
import { Actions } from '@/pages/Candidate/view/constants';
import { CandidateEditStatus } from '@/pages/Candidate/actions';
import { RootState } from '@/store';
import CandidateShowTabs, { CandidateShowLoading } from '@/pages/Candidate/view/CandidateShowTabs';
import { ShowStyled } from '@/pages/Candidate/view/styled';

const CandidateView = (props: ShowProps) => {
  const { isLoading } = useSelector((state: RootState) => state.turnAdmin);
  const [editStatus, setEditStatus] = useState(false);

  const toggleEditStatus = () => setEditStatus((prev) => !prev);

  return (
    <ShowStyled {...props} actions={!editStatus ? <Actions setEditStatus={toggleEditStatus} /> : null}>
      {isLoading && <CandidateShowLoading />}
      {editStatus ? <CandidateEditStatus toggleEditStatus={toggleEditStatus} {...props} /> : <CandidateShowTabs />}
    </ShowStyled>
  );
};

export default CandidateView;
